import { MicroMoments } from '../models/micro-moments.interfaces';

export const MicroMomentsLyftNewContentMocks: MicroMoments = {
  id: '',
  title: 'Earn More Miles With Lyft',
  description:
    'Link your SkyMiles and Lyft account and earn miles on all Lyft rides in the U.S.',
  action: {
    label: 'Link Your Account',
    url: 'https://www.deltalyft.com/'
  },
  logo: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/lyft-logo.svg',
    alt: 'Lyft Logo image'
  },
  tag: {
    title: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/lyft-car-desktop.svg',
      alt: 'Lyft car image'
    }
  },
  close: {
    path: '#',
    alt: 'close'
  },
  ariaLabel: {
    close: 'Close Micromoment'
  },
  disabled: false,
  loaded: true
};
